import {
    type UpdateNewsResponseType,
    type UpdateNewsRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateNews = async (params: UpdateNewsRequestType): Promise<UpdateNewsResponseType> => {
    return await request<UpdateNewsResponseType>("/news/updateNews", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default UpdateNews;
